<template>
    <div class="vue-custom-autocomplete position-relative">
        <input type="search" id="place" name="place" v-model="place" :placeholder="$t('autocomplete.placeholder')" class="form-control" v-on:input="callApi" autocomplete="off" required
            :class="this.preciseData > 1 ? 'is-valid' : (this.preciseData == 1 ? 'is-invalid not-precise' : (this.preciseData == 0 ? 'is-invalid' : ''))">
        <div :class="'dropdown-menu ' + (dropdownShow ? 'show' : 'hide')">
            <div v-if="!search || (search && search.length == 0)" class="dropdown-item-text">
                <span>{{ $t('autocomplete.no_result') }}</span>
            </div>
            <div v-else class="dropdown-item-text">
                <span v-for="item in this.search" class="dropdown-item" v-on:click="chooseAddress(item.description)">{{ item.description }}</span>
            </div>
            <div class="google-logo">
                <img src="/img/google_on_white.png">
            </div>
        </div>
        <div :class="'loader ' + (spinnerShow ? 'show' : 'hide')">{{ $t('autocomplete.loading') }}</div>
        <i :class="'fas fa-check text-primary check-ico ' + (checkGeoIcon ? 'd-inline-block' : 'd-none')"></i>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "custom-autocomplete",

        props: {
            googleKey: String,
            corsUrl: String,
            value: String,
            checkPreciseAddress: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
            return {
                fallback: null,
                search: null,
                timeout: null,
                dropdownShow: false,
                checkGeoIcon: false,
                spinnerShow: false,
                preciseData: null,
                wait: 1000,
                options: {
                    language: 'cs',
                    components: "country:cz"
                }
            }
        },

        created: function () {
            let self = this

            $('body').click(function(e) {
                if ($(e.target).closest('.dropdown-menu').length === 0) {
                    self.dropdownShow = false
                }
            });
        },

        methods: {
            callApi: function () {
                let self = this
                self.preciseData = null
                self.dropdownShow = false

                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                    this.spinnerShow = false
                }

                this.spinnerShow = true
                this.timeout = setTimeout(function () {
                    let axios = require('axios');
                    let targetUrl = self.prepareUrl()

                    let regex = new RegExp("^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?),\\s*[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$");
                    let input = document.getElementById('place').value;

                    let config = {
                        method: 'get',
                        url: targetUrl,
                        headers: { }
                    };

                    axios(config)
                        .then(function (response) {
                            self.search = response.data.predictions

                            if ((response.data.predictions.length === 0) && (regex.test(input))) {
                                self.dropdownShow = false
                                self.checkGeoIcon = true

                                if (self.checkPreciseAddress) {
                                    self.chooseAddress(input)
                                }
                            } else {
                                self.dropdownShow = true
                                self.checkGeoIcon = false
                            }

                            if (!regex.test(input) && self.search.length === 0) {
                                self.preciseData = 0
                            }

                            self.spinnerShow = false
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }, self.wait)
            },

            prepareUrl: function () {
                let url = "https://maps.googleapis.com/maps/api/place/autocomplete/json?input=<INPUT>&key=<API_KEY>"

                url = url.replace("<INPUT>", encodeURIComponent(this.place))
                url = url.replace("<API_KEY>", this.googleKey)

                for (const [key, value] of Object.entries(this.options)) {
                    url = url.concat('&' + key + '=' + value)
                }

                if (this.corsUrl) {
                    url = this.corsUrl.concat("?targetUrl=" + btoa(url))
                }

                return url
            },

            chooseAddress: function (address) {
                this.place = address
                this.dropdownShow = false

                if (this.checkPreciseAddress) {
                    let axios = require('axios')
                    let self = this

                    let config = {
                        method: 'post',
                        url: "/reproduction/ajax/precise-address",
                        headers: { },
                        data: {address: this.place},
                    };

                    axios(config).then(function (response) {
                        self.preciseData = response.data.address_score

                        if (response.data.location !== '') {
                            let streetViewPointFound = response.data.azimuth !== null

                            document.getElementById('map-view-0').setAttribute('data-location', response.data.location)
                            document.getElementById('pano-view-0').setAttribute('data-location', response.data.location)
                            document.getElementById('street-view-0').setAttribute('data-location', response.data.location)
                            document.getElementById('street-view-0').setAttribute('data-azimuth', response.data.azimuth)
                            document.getElementById('reproduction-embed-maps').style.removeProperty('display');

                            if (streetViewPointFound) {
                                document.getElementById('panorama-0').style.setProperty('display', 'none')
                                document.getElementById('panorama-tab-0').style.setProperty('display', 'none')
                                document.getElementById('streetview-tab-0').style.removeProperty('display')
                                document.getElementById('streetview-tab-0').click()
                            } else {
                                document.getElementById('panorama-0').style.removeProperty('display')
                                document.getElementById('panorama-tab-0').style.removeProperty('display')
                                document.getElementById('streetview-tab-0').style.setProperty('display', 'none')
                                document.getElementById('panorama-tab-0').click()
                            }
                        }

                        if (document.getElementsByName('built_up_area').length > 0 && response.data.cuzk_data && response.data.cuzk_data['st_area(shape)']) {
                            document.getElementsByName('built_up_area')[0].value = parseInt(response.data.cuzk_data['st_area(shape)'])
                        }
                        if (document.getElementsByName('above_ground_floors').length > 0 && response.data.cuzk_data && response.data.cuzk_data['pocetpodlazi']) {
                            document.getElementsByName('above_ground_floors')[0].value = response.data.cuzk_data['pocetpodlazi']
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            }
        },

        computed: {
            place: {
                get() {
                    return this.fallback ?? this.value
                },

                set(val){
                    this.$emit('input', val)
                    this.fallback = val
                }
            }
        }
    }
</script>
